import React, {Component} from 'react';
import {XYChart, BarSeries, CrossHair, XAxis} from '@data-ui/xy-chart';
import moment from 'moment';
import './dispatch.css';
import {ApplicationActions} from "../../../data/Action";


export default class DispatchGraph extends Component {


    render() {


        const scheduledOrders = (this.props.scheduled ? this.props.scheduled : []);


        const timeSeriesData = this.computeTimeSeries(scheduledOrders);

        const domainMin = 30;
        const domainMax = domainMin + 70;

        return (
            <div className={'dispatch-graph-display'}>
                <XYChart
                    ariaLabel={"Dispatch Events"}
                    width={300}
                    height={125}
                    margin={{top: 0, right: 0, bottom: 30, left: 0}}
                    xScale={{type: 'linear', domain: [domainMin, domainMax]}}
                    yScale={{type: 'linear'}}
                    renderTooltip={({event, datum, data, color}) => (
                        <div>
                            <div>Encomendas: <strong>{datum.y} </strong></div>
                            <div>Valor: <strong>€{datum.info.amount}</strong></div>
                        </div>
                    )}
                    snapTooltipToDataX
                >
                    <XAxis
                        numTicks={5}
                        tickFormat={this.formatXAxisTick.bind(this)}
                    />

                    <CrossHair showHorizontalLine={false} fullHeight stroke="pink"/>

                    <BarSeries
                        data={timeSeriesData}
                        fill="#22b8cf"
                        barWidth="2"
                        onClick={this.onGroupClick.bind(this)}
                    />
                </XYChart>
            </div>
        );
    }


    computeTimeSeries(scheduledData) {
        let seriesData = [];

        if (!scheduledData || scheduledData.length === 0) {
            return seriesData;
        }

        let buckets = {
            30: {x: 37.5, y: 0, info: {date: moment().add(30, 'm').format("HH:mm"), orders: [], amount: 0.0}},
            45: {x: 52.5, y: 0, info: {date: moment().add(45, 'm').format("HH:mm"), orders: [], amount: 0.0}},
            60: {x: 67.5, y: 0, info: {date: moment().add(60, 'm').format("HH:mm"), orders: [], amount: 0.0}},
            75: {x: 82.5, y: 0, info: {date: moment().add(75, 'm').format("HH:mm"), orders: [], amount: 0.0}},
            90: {x: 97.5, y: 0, info: {date: moment().add(90, 'm').format("HH:mm"), orders: [], amount: 0.0}},
        };

        scheduledData.forEach(order => {
            let timeToDispatch = moment().diff(order.deliveryDate);
            let minutes = Math.floor(Math.abs(timeToDispatch / 60000));

            let bucket = undefined;
            if (minutes >= 30 && minutes < 45) {
                bucket = buckets[30];
            } else if (minutes >= 45 && minutes < 60) {
                bucket = buckets[45];
            } else if (minutes >= 60 && minutes < 75) {
                bucket = buckets[60];
            } else if (minutes >= 75 && minutes < 90) {
                bucket = buckets[75];
            } else if (minutes >= 90 && minutes < 105) {
                bucket = buckets[90];
            } else {
                console.debug("DispatchGraph: Value out of buckets (" + minutes + ")");
            }


            if (bucket) {
                bucket.y++;
                bucket.info.orders.push(order);
                bucket.info.amount += Math.round(order.total);
            }

        });


        Object.values(buckets).forEach(value => {
            seriesData.push(value);
        });

        return seriesData;
    }


    onGroupClick(event) {
        console.log("onGroupClick: " + JSON.stringify(event.datum));

        let scheuledOrders = [];

        if (event.datum.info && event.datum.info.orders) {
            scheuledOrders = event.datum.info.orders;
        }

        if (scheuledOrders != null && scheuledOrders.length > 0) {
            ApplicationActions.onClickScheduledFastForward(scheuledOrders);
        }
    }


    formatXAxisTick(tick, tickIndex) {
        if ((tick % 10) === 0) {
            return tick;
        }
        return null;
    }
}


// WEBPACK FOOTER //
// ./src/app/Statistics/Dispatch/index.js